var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-desc"
  }, [_c('div', {
    staticClass: "desc-wrap"
  }, [_c('div', {
    staticClass: "arrow",
    class: {
      up: !_vm.introState
    },
    on: {
      "click": function click($event) {
        return _vm.changeState();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('liveroom.personalCard.aboutMe')) + "\n        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.introState,
      expression: "introState"
    }],
    staticClass: "intro"
  }, [_vm._v("\n           " + _vm._s(_vm.userInfo && _vm.userInfo.usign || ' ') + "\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.basicInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.birthday')) + ":")]), _vm._v(_vm._s(_vm.userInfo && _vm.userInfo.birthday || _vm.$t('liveroom.personalCard.unknow')))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.constellation')) + ":")]), _vm._v(_vm._s(_vm.userInfo && _vm.userInfo.constellation && _vm.$t("liveroom.personalCard.constellation".concat(_vm.userInfo.constellation)) || _vm.$t('liveroom.personalCard.unknow')))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };